import { atomWithStorage } from 'jotai/utils'

import type { TimeUnit, User, UserRole } from '@/graphql/generated-types'

type Session = {
  user?: User
  token?: string
  timeUnit?: TimeUnit
  locationId?: string
  customerId?: string
  role?: UserRole
  version?: string
}

export const sessionAtom = atomWithStorage<Session | undefined>(
  'spoton-user',
  undefined
)
